function itineraries() {

    function getAjax(url, dataNum) {
        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open('GET', url);
        xhr.onreadystatechange = function() {
            if (xhr.readyState>3 && xhr.status==200) {
                displayResult(xhr.responseText, dataNum);
            } else if (xhr.status !== 200) {
                console.log('Request failed.  Returned status of ' + xhr.status + ' and a ready state of ' + xhr.readyState);
            }
        };
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.send();
        return xhr;
    }

    document.querySelectorAll("#itineraries .listing-item .more").forEach(function(moreLessBtn){
        moreLessBtn.onclick = function(event) {
            
            if (event.target.classList.contains('noexpand')) {
                // Do nothing, let the browser follow the link's href
            } else {
                var moreDetailsPanel = event.target.closest(".extra");
                if (event.target.innerHTML.toLowerCase() == 'more +') {
                    moreDetailsPanel.classList.add('in');
                    event.target.innerHTML = 'LESS -';
                } else {
                    moreDetailsPanel.classList.remove('in');
                    event.target.innerHTML = 'MORE +';
                }
                event.preventDefault();
            }
        }   
    })

    document.querySelectorAll("#itineraryBudget a").forEach(function(itinerarySection){

        if (itinerarySection) {
            itinerarySection.onclick = function(event) {

                var firstRow = document.querySelector("#itineraryArea .selected");
                var firstDataTab = (firstRow) ? firstRow.getAttribute("data-tab") : 1;

                var dataTab = event.target.getAttribute("data-tab");
                var script = SITE_URL+"ajax/responsive/get_itineraries.php?facelift=1&tabs="+firstDataTab+','+dataTab;
                getAjax(script, dataTab);

                document.querySelectorAll("#itineraryBudget a").forEach(function(itineraryTab){
                    itineraryTab.classList.remove('selected');
                });
                itinerarySection.classList.add('selected');
            }
        }
    });

    function displayResult(result, dataTab) {

        document.querySelectorAll(".listing-wrapper .tab").forEach(function(itinerarypanel){
            itinerarypanel.classList.remove('selected');
            if (dataTab == itinerarypanel.getAttribute("data-tab")) {
                itinerarypanel.classList.add('selected');
                itinerarypanel.innerHTML = result;
            }
        });
    }
}

export default itineraries;